module.exports = __webpack_public_path__ + "img/remove-colored-icon.d29eaf06.svg";